'use client';

import { createContext, use } from 'react';

import type { PropsWithChildren } from 'react';

interface ServerStateContextValue {
  headers: {
    cookie?: string;
  };
}

const ServerStateContext = createContext<ServerStateContextValue | null>(null);

export function useServerState(): ServerStateContextValue {
  const context = use(ServerStateContext);
  if (!context) {
    throw new Error('useServerState must be used within a ServerStateProvider');
  }
  return context;
}

export default function ServerStateProvider({
  children,
  state,
}: PropsWithChildren<{ state: ServerStateContextValue }>) {
  return <ServerStateContext.Provider value={state}>{children}</ServerStateContext.Provider>;
}
